import React, {useEffect, useState} from 'react';
import {createPortal} from 'react-dom';
import {CSSTransition} from 'react-transition-group';
import clsx from 'clsx';

import {
  addSearchParamToUrl,
  disableScroll,
  enableScroll,
  getIconSportUrl,
  getPhotoAthletUrl,
  getTagUrl,
  removeSearchParamToUrl
} from '../utils/helpers';

import ArrowIcon from './arrow-icon';

import styles from './athletes-side-modal.module.css';

export default ({
  toggleSideModal,
  athletes,
  name,
  id,
  domain,
  themeColor,
  withSportImages = true,
  pathToSportIcons,
  pathToAthletPhotos,
  backButtonModalClassName,
  athletNameModalClassName,
  backButtonIconModalClassName,
  backButtonTextModalClassName,
  modalContentClassName,
  sportInfoModalClassName,
  athletModalClassName,
  athletImageExtension
}) => {
  const [inProp, setInProp] = useState(true);

  const handleClose = () => {
    setInProp(false);

    setTimeout(() => toggleSideModal({isOpen: false, props: {}}), 250);
  };

  useEffect(() => {
    disableScroll();
    addSearchParamToUrl(id);

    return () => {
      removeSearchParamToUrl();
      enableScroll();
    };
  }, []);

  const renderContent = () => (
    <>
      <div className={clsx(styles.sportInfo, sportInfoModalClassName)}>
        {withSportImages && (
          <img
            src={getIconSportUrl(id, pathToSportIcons)}
            className={styles.sportInfoIcon}
            alt={name}
          />
        )}
        <p className={styles.sportInfoTitle}>{name}</p>
      </div>
      <ul>
        {athletes.map(athlet => (
          <li key={athlet.id}>
            <a
              href={getTagUrl(domain, athlet.id)}
              className={clsx(styles.athlet, athletModalClassName)}
            >
              <img
                src={getPhotoAthletUrl(athlet.id, pathToAthletPhotos, athletImageExtension)}
                className={styles.athletImage}
                alt={athlet.name}
              />
              <p className={clsx(styles.athletName, athletNameModalClassName)}>{athlet.name}</p>
            </a>
          </li>
        ))}
      </ul>
    </>
  );

  return createPortal(
    <div className={styles.sideModal}>
      <CSSTransition
        in={inProp}
        timeout={250}
        classNames='sideLeft'
        appear
      >
        <div
          className={clsx(styles.modalContent, modalContentClassName)}
          style={{'--background-color': `${themeColor}`}}
        >
          <button
            className={clsx(styles.button, backButtonModalClassName)}
            onClick={handleClose}
          >
            <ArrowIcon className={clsx(styles.arrowIcon, backButtonIconModalClassName)} />
            <span className={clsx(styles.buttonText, backButtonTextModalClassName)}>Назад</span>
          </button>
          {renderContent()}
        </div>
      </CSSTransition>
      <CSSTransition
        in={inProp}
        timeout={250}
        classNames='fade'
        appear
      >
        <div
          onClick={handleClose}
          className={styles.backdrop}
        />
      </CSSTransition>
    </div>
    , document.body);
};
